import React from 'react';
import PublicLayoutStyled from '../../../../styledComponents/Public.layout.styled';
import WelcomePageContent from './Welcome.page.content';

async function action() {
  return {
    title: 'Welcome',
    component: (
      <PublicLayoutStyled>
        <WelcomePageContent />
      </PublicLayoutStyled>
    ),
  };
}

export default action;
